var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41021 6.27756C7.52236 6.10952 7.52236 5.89048 7.41021 5.72244L4.07668 0.727718C3.80213 0.316352 3.1608 0.51071 3.1608 1.00528L3.1608 3.19166L1 3.19166C0.723857 3.19166 0.5 3.41552 0.5 3.69166L0.5 8.06241C0.5 8.33855 0.723857 8.56241 1 8.56241L3.1608 8.56241L3.1608 10.9947C3.1608 11.4893 3.80213 11.6836 4.07668 11.2723L7.41021 6.27756Z",
    fill: "#4893CF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSame);
export default __webpack_public_path__ + "static/media/Same.296901988d7ca138018079146164a85e.svg";
export { ForwardRef as ReactComponent };